import { Link } from "react-router-dom";
import logo from "../../../assets/logo.svg";
import L from "../../../constants/baysportLabels";
import PortalSwitcher from "../PortalSwitcher";
import AuthSteps from "./AuthSteps";
import a from "./auth.module.css";

export default function AuthShell({
  backTo = "/",
  backLabel = "Назад",
  showSwitcher = true,
  showTrust = false,
  showBrand = true,
  wide = false,
  cardTitle,
  hint,
  clubTag,
  stepCurrent,
  stepTotal,
  stepLabels,
  segment,
  modern = false,
  children,
  footer,
}) {
  const hasSteps =
    stepCurrent != null &&
    stepTotal != null &&
    stepTotal > 1 &&
    Array.isArray(stepLabels) &&
    stepLabels.length > 0;

  const hasHead = Boolean(cardTitle || hint || hasSteps);

  return (
    <div className={`${a.page} ${modern ? a.pageModern : ""}`}>
      <div className={a.center}>
        {!modern ? (
          <header className={a.topBar}>
            <Link to={backTo} className={a.backLink}>
              ← {backLabel}
            </Link>
            {showSwitcher ? (
              <PortalSwitcher />
            ) : (
              <span className={a.topBarSpacer} aria-hidden />
            )}
          </header>
        ) : null}

        {modern ? (
          <header className={a.modernTopBar}>
            <Link to={backTo} className={a.modernBack}>
              ← {backLabel}
            </Link>
          </header>
        ) : null}

        {showBrand && modern ? (
          <div className={a.modernBrand}>
            <img src={logo} alt="" className={a.pageBrandLogo} width={40} height={40} />
            <span className={a.modernBrandName}>{L.productName}</span>
          </div>
        ) : null}

        {showBrand && !modern ? (
          <div className={a.pageBrand}>
            <img src={logo} alt="" className={a.pageBrandLogo} width={32} height={32} />
            <span className={a.pageBrandName}>{L.productName}</span>
          </div>
        ) : null}

        {segment}

        <div className={`${a.card} ${wide ? a.cardWide : ""} ${modern ? a.cardModern : ""}`}>
          {modern && (clubTag || cardTitle || hint || hasSteps) ? (
            <div className={a.modernHead}>
              {clubTag ? <span className={a.clubTag}>{clubTag}</span> : null}
              {cardTitle ? <h1 className={a.modernTitle}>{cardTitle}</h1> : null}
              {hasSteps ? (
                <AuthSteps
                  current={stepCurrent}
                  total={stepTotal}
                  labels={stepLabels}
                />
              ) : null}
              {hint ? <p className={a.modernSubtitle}>{hint}</p> : null}
            </div>
          ) : null}

          {hasHead && !modern ? (
            <div className={a.cardHead}>
              {cardTitle ? <h1 className={a.title}>{cardTitle}</h1> : null}
              {hasSteps ? (
                <AuthSteps
                  current={stepCurrent}
                  total={stepTotal}
                  labels={stepLabels}
                />
              ) : null}
              {hint ? <p className={a.subtitle}>{hint}</p> : null}
            </div>
          ) : null}

          <div className={a.body}>{children}</div>

          {footer ? <div className={a.foot}>{footer}</div> : null}
        </div>

        {showTrust ? (
          <p className={a.trustLine}>Журнал · Абонементы · Группы</p>
        ) : null}
      </div>
    </div>
  );
}
